import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE, CLEAR_AUTH_ERROR } from '../actions/authActions';
import { AUTH_LOGOUT, AUTH_VALIDATE_SUCCESS, TOKEN_LOGIN_REQUEST, TOKEN_LOGIN_SUCCESS, TOKEN_LOGIN_FAILURE } from '../actions/validateAction';

const initialState = {
  token: localStorage.getItem('token') || null,
  user: null,
  loading: false,
  error: null,
  signupResponse: null,
  tokenLoginLoading: false,
  tokenLoginError: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
    case SIGNUP_REQUEST:
      return { ...state, loading: true, error: null };
    case LOGIN_SUCCESS:
      return { ...state, loading: false, token: action.payload?.token || null };
    case AUTH_VALIDATE_SUCCESS:
      return {
        ...state,
        user: action.payload?.user || null,
        token: action.payload?.token || state.token,
      };
    case SIGNUP_SUCCESS:
      return { ...state, loading: false, signupResponse: action.payload };
    case LOGIN_FAILURE:
    case SIGNUP_FAILURE:
      return { ...state, loading: false, error: action.error };
    case CLEAR_AUTH_ERROR:
      return { ...state, error: null };
    case AUTH_LOGOUT:
      return { ...state, token: null, user: null };
    case TOKEN_LOGIN_REQUEST:
      return { ...state, tokenLoginLoading: true, tokenLoginError: null };
    case TOKEN_LOGIN_SUCCESS:
      return {
        ...state,
        tokenLoginLoading: false,
        token: action.payload?.token || null,
        user: action.payload?.user || null,
        tokenLoginError: null,
      };
    case TOKEN_LOGIN_FAILURE:
      return {
        ...state,
        tokenLoginLoading: false,
        tokenLoginError: action.error,
        token: null,
        user: null,
      };
    default:
      return state;
  }
}
